import { GetLfaConversionFilterType } from '~/graphql/types';
import type { CardStatus } from '../getFrontendStatus';
import getTodayFormatted from '../getTodayFormatted';

const text = {
  TODAY_NO_TIME: 'Vandaag (geen tijd afgesproken)',
  TODAY_WITH_TIME: 'Vandaag om',
  NO_TIME: '(geen tijd afgesproken)',
  APPOINTMENT_PREFIX: 'Afspraak op:',
  AT_TIME: 'om',
};

type AppointmentLabelArgs = {
  date: string;
  time?: string;
  filter: GetLfaConversionFilterType;
  status: CardStatus;
};

/**
 * Generates contextual appointment date/time label
 * Handles special cases for today's appointments in different contexts
 */
const getAppointmentDateTimeLabel = ({
  date,
  time,
  filter,
  status,
}: AppointmentLabelArgs): string => {
  const today = getTodayFormatted();
  const isToday = date === today;
  const isTodayFilter = filter === GetLfaConversionFilterType.Today;
  const isPreparing = status === 'prepareForAppointment';

  // Special handling for today's appointments when preparing
  if (isTodayFilter && isToday && isPreparing) {
    return time ? `${text.TODAY_WITH_TIME} ${time}` : text.TODAY_NO_TIME;
  }

  // Standard appointment label format
  const timeDisplay = time ? `${text.AT_TIME} ${time}` : text.NO_TIME;

  return `${text.APPOINTMENT_PREFIX} ${date} ${timeDisplay}`;
};

export default getAppointmentDateTimeLabel;
